module.exports = __webpack_public_path__ + "static/media/wand-dark.91a7b59a.svg";